import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/termos')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <div
      className="min-h-[60vh] bg-[#CCD0CF] text-[#06141B]"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div className="mx-auto max-w-4xl px-6 py-12 space-y-8">
        <h1 className="text-2xl sm:text-3xl font-semibold mb-2">
          Termos e Condições de Uso — Prometeus
        </h1>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">1) Identificação e aceite</h2>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>1.1.</strong> Estes Termos e Condições de Uso (“Termos”) regulam o acesso e uso da plataforma Prometeus (“Plataforma”), destinada à organização e gestão de rotinas jurídicas e administrativas do usuário.
            </p>
            <p>
              <strong>1.2.</strong> Ao acessar, cadastrar-se, contratar plano, ou usar a Plataforma, o usuário declara que leu, entendeu e concorda com estes Termos.
            </p>
            <p>
              <strong>1.3.</strong> Se o usuário não concordar com qualquer disposição, deve interromper o uso e solicitar o cancelamento, quando aplicável.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">2) Definições</h2>
          <p className="text-sm text-[#253745] mb-3">Para fins destes Termos:</p>
          <div className="space-y-2 text-sm text-[#253745] ml-4">
            <p><strong>“Usuário”</strong>: pessoa física ou representante de pessoa jurídica que utiliza a Plataforma.</p>
            <p><strong>“Conta”</strong>: credenciais e ambiente do usuário na Plataforma.</p>
            <p><strong>“Conteúdo”</strong>: dados inseridos/carregados pelo usuário (ex.: processos, clientes, documentos, tarefas, tags, observações).</p>
            <p><strong>“Plano”</strong>: modalidade de assinatura (gratuita/beta/paga) com limites e funcionalidades específicas.</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">3) Elegibilidade e cadastro</h2>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>3.1.</strong> O usuário declara ter capacidade civil e poderes para aceitar estes Termos em nome próprio ou da organização que representa.
            </p>
            <p>
              <strong>3.2.</strong> O usuário se compromete a fornecer dados corretos e atualizados no cadastro e a manter a confidencialidade das credenciais.
            </p>
            <p>
              <strong>3.3.</strong> O usuário é responsável por toda atividade realizada na Conta, inclusive por acessos de colaboradores e terceiros autorizados.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Uso da plataforma</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">4) Licença de uso e limitações</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>4.1.</strong> A Plataforma é licenciada, não vendida; concede-se ao usuário uma licença revogável, não exclusiva e intransferível para uso conforme o Plano contratado e estes Termos.
            </p>
            <p>
              <strong>4.2.</strong> É proibido: (i) engenharia reversa, (ii) exploração de vulnerabilidades, (iii) cópia substancial da interface/fluxos, (iv) revenda/locação, (v) uso para fins ilícitos.
            </p>
            <p>
              <strong>4.3.</strong> O uso deve observar boas práticas e legislação aplicável, inclusive sigilo profissional e proteção de dados pessoais.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">5) Conteúdo do usuário e responsabilidades</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>5.1.</strong> O usuário mantém a titularidade do Conteúdo inserido na Plataforma e concede autorização para processamento apenas para prestar o serviço (armazenar, organizar, exibir, gerar relatórios, etc.).
            </p>
            <p>
              <strong>5.2.</strong> O usuário é o único responsável pela veracidade, legalidade e base jurídica do Conteúdo (incluindo dados pessoais de clientes/terceiros), bem como por permissões e comunicações necessárias.
            </p>
            <p>
              <strong>5.3.</strong> O Prometeus não substitui análise jurídica, prazos processuais oficiais, nem garante resultado em processos; a Plataforma é ferramenta de apoio à gestão.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">6) Relatórios e outputs</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>6.1.</strong> A Plataforma pode permitir a geração de relatórios e documentos para clientes com configurações escolhidas pelo usuário.
            </p>
            <p>
              <strong>6.2.</strong> O usuário deve revisar outputs antes de enviar a terceiros, pois a exatidão depende dos dados cadastrados e dos filtros escolhidos.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Planos, cobrança e cancelamento</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">7) Planos, contratação e renovação</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>7.1.</strong> Funcionalidades e limites variam por Plano; detalhes devem estar descritos na página de planos/contratação ou proposta comercial.
            </p>
            <p>
              <strong>7.2.</strong> Em planos pagos, a assinatura pode ser recorrente e renovar automaticamente ao fim do ciclo, salvo cancelamento antes da renovação.
            </p>
            <p>
              <strong>7.3.</strong> Tributos podem ser incluídos no preço final ou cobrados conforme a legislação aplicável e o tipo de contratação.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">8) Cancelamento</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>8.1.</strong> O usuário pode solicitar cancelamento a qualquer momento, e a assinatura permanece ativa até o fim do período já pago, salvo regra diversa em oferta específica.
            </p>
            <p>
              <strong>8.2.</strong> As regras detalhadas (prazo, efeitos, retenção e exportação) devem seguir a Política de Cancelamento vigente, se publicada como documento complementar.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">9) Reembolso (quando aplicável)</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>9.1.</strong> Reembolsos, quando previstos, seguirão a Política de Reembolso e Devolução vigente, quando publicada, ou condições específicas de proposta/contrato.
            </p>
            <p>
              <strong>9.2.</strong> O simples cancelamento não implica reembolso automático, salvo previsão expressa.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Privacidade, segurança e disponibilidade</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">10) Privacidade e proteção de dados</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>10.1.</strong> O tratamento de dados pessoais deve seguir a Política de Privacidade da Plataforma (documento específico).
            </p>
            <p>
              <strong>10.2.</strong> O usuário reconhece que poderá inserir dados de terceiros (clientes/partes) e se compromete a tratá-los conforme as bases legais e deveres aplicáveis, especialmente em contexto jurídico.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">11) Segurança e incidentes</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>11.1.</strong> O Prometeus adota medidas de segurança razoáveis para proteger a Plataforma, mas nenhum sistema é totalmente livre de riscos.
            </p>
            <p>
              <strong>11.2.</strong> O usuário deve adotar boas práticas (senhas fortes, controle de acessos, revogação de acessos de ex-colaboradores) e comunicar suspeitas de uso indevido.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">12) Disponibilidade e manutenção</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>12.1.</strong> A Plataforma pode passar por manutenções programadas e indisponibilidades pontuais; quando possível, haverá comunicação prévia.
            </p>
            <p>
              <strong>12.2.</strong> Não há garantia de disponibilidade ininterrupta, salvo se houver SLA contratual específico.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Propriedade intelectual e condutas</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">13) Propriedade intelectual</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>13.1.</strong> Marca, software, interface, layout, textos da Plataforma, logotipos e demais elementos são protegidos por direitos de propriedade intelectual do Prometeus ou licenciadores.
            </p>
            <p>
              <strong>13.2.</strong> Nenhuma disposição transfere ao usuário qualquer direito de propriedade sobre a Plataforma, além da licença limitada de uso.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">14) Condutas proibidas</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>14.1.</strong> É vedado usar a Plataforma para: (i) violar sigilo, (ii) armazenar conteúdo ilegal, (iii) praticar spam, (iv) tentar acesso não autorizado, (v) interferir no funcionamento do serviço.
            </p>
            <p>
              <strong>14.2.</strong> O descumprimento pode resultar em suspensão ou encerramento da Conta, sem prejuízo de medidas legais cabíveis.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Encerramento, retenção e suporte</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">15) Suspensão e encerramento</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>15.1.</strong> O Prometeus pode suspender ou encerrar contas em caso de: violação destes Termos, risco de segurança, ordem judicial/autoridade competente, ou inadimplência, conforme política comercial.
            </p>
            <p>
              <strong>15.2.</strong> Sempre que possível, será dado aviso e oportunidade de regularização, exceto em casos graves (fraude, ataque, risco imediato).
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">16) Retenção e exclusão de dados</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>16.1.</strong> Após o encerramento efetivo, o Prometeus poderá manter dados por um período de retenção para exportação e reativação, quando tecnicamente viável e permitido.
            </p>
            <p>
              <strong>16.2.</strong> Após esse prazo, os dados podem ser excluídos ou anonimizados, observadas obrigações legais e de segurança.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">17) Suporte e comunicações</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>17.1.</strong> O suporte e o canal oficial de comunicação (e-mail/whatsapp/helpdesk) devem ser informados no site ou dentro da Plataforma.
            </p>
            <p>
              <strong>17.2.</strong> Comunicações sobre cobrança, mudanças relevantes e segurança podem ocorrer por e-mail e/ou notificações no sistema.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Disposições gerais</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">18) Alterações nos termos</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>18.1.</strong> O Prometeus pode atualizar estes Termos para refletir mudanças legais, de produto ou operacionais.
            </p>
            <p>
              <strong>18.2.</strong> Quando a alteração impactar materialmente direitos e obrigações, recomenda-se aviso prévio e indicação de data de vigência.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">19) Limitação de responsabilidade</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>19.1.</strong> Na máxima extensão permitida, o Prometeus não se responsabiliza por: (i) decisões tomadas pelo usuário com base nos dados cadastrados, (ii) perdas por falhas de internet/dispositivos do usuário, (iii) danos indiretos/lucros cessantes.
            </p>
            <p>
              <strong>19.2.</strong> Se houver responsabilidade reconhecida, pode ser limitada ao valor pago pelo usuário à Plataforma em período determinado (ex.: últimos 3 ou 12 meses), se isso fizer sentido comercialmente e for permitido.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">20) Lei aplicável e foro</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              <strong>20.1.</strong> Estes Termos são regidos pelas leis da República Federativa do Brasil.
            </p>
            <p>
              <strong>20.2.</strong> O foro para dirimir controvérsias poderá ser definido conforme domicílio do consumidor (quando aplicável) ou conforme cláusula específica para contratos B2B, respeitando limites legais.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

